"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable @typescript-eslint/no-non-null-assertion */
// @ts-nocheck
const Tile_1 = __importDefault(require("ol/layer/Tile"));
const BingMaps_1 = __importDefault(require("ol/source/BingMaps"));
const OSM_1 = __importDefault(require("ol/source/OSM"));
const emptyData = {
    provider: 'OpenStreetMaps',
    key: '',
};
class MapLayer {
    constructor(data = emptyData) {
        this.provider = data.provider || '';
        this.key = data.key || '';
    }
    get layers() {
        let layers = new Tile_1.default({ source: null });
        if (this.provider === 'BingMaps') {
            layers = new Tile_1.default({
                source: new BingMaps_1.default({
                    key: this.key,
                    imagerySet: 'AerialWithLabels',
                }),
                preload: Infinity,
            });
        }
        else if (this.provider === 'OpenStreetMaps') {
            layers = new Tile_1.default({
                source: new OSM_1.default(),
                preload: Infinity,
            });
        }
        layers.set('id', 'base-layer');
        return [layers];
    }
}
exports.default = MapLayer;
